import { Action, createReducer, on } from '@ngrx/store';
import * as UploadPictureActions from './upload-picture.actions';

export const UPLOAD_PICTURE_FEATURE_KEY = 'upload-picture';

export interface UploadPictureState {
  verified: boolean;
  verifying: boolean;
  uploaded: boolean;
  uploading: boolean;
  error?: string | null;
}

export interface UploadPicturePartialState {
  readonly [UPLOAD_PICTURE_FEATURE_KEY]: UploadPictureState;
}

export const initialUploadPictureState: UploadPictureState = {
  uploaded: false,
  uploading: false,
  error: null,
  verified: false,
  verifying: false,
};

const reducer = createReducer(
  initialUploadPictureState,
  on(UploadPictureActions.uploadPicture, (state) => ({
    ...state,
    uploading: true,
    uploaded: false,
    error: null,
  })),
  on(UploadPictureActions.uploadPictureSuccess, (state) => ({
    ...state,
    uploading: false,
    uploaded: true,
  })),
  on(UploadPictureActions.uploadPictureFailure, (state, { error }) => ({
    ...state,
    uploading: false,
    uploaded: false,
    error,
  })),
  on(UploadPictureActions.verifyWithPicture, (state) => ({
    ...state,
    verified: false,
    verifying: true,
  })),
  on(UploadPictureActions.verifyWithPictureSuccess, (state) => ({
    ...state,
    verified: true,
    verifying: false,
  })),
  on(UploadPictureActions.verifyWithPictureFailure, (state, { error }) => ({
    ...state,
    verified: false,
    verifying: false,
    error,
  })),
  on(UploadPictureActions.cleanError, (state) => ({
    ...state,
    error: null,
  })),
  on(UploadPictureActions.resetState, () => initialUploadPictureState),
);

export function uploadPictureUploadPictureReducer(
  state: UploadPictureState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
